import { useParams } from 'react-router-dom';
import { useData } from '../DataContext';
import FeatureLabel from '../components/FeatureLabel';
import { Link } from "react-router-dom";


const BlogPage = () => {
    const { id } = useParams(); // gets blog ID from URL
    const { blogs, isLoadingBlogs, error } = useData();

    if (isLoadingBlogs) return <p>Loading blog...</p>;
    if (error) return <p>{error}</p>;

    const blog = blogs.find(b => String(b.ID) === id);
    if (!blog) return <p>Blog not found.</p>;

    return (
        <>

        <div className="absolute inset-0 z-0 w-screen left-1/2 right-1/2 -mx-[50vw]">
            <img className="w-full" src={require("../media/images/StarSplash.png")} />
        </div>
        <div className="flex flex-col items-center px-4 md:px-20 py-12 z-10 relative">
            <Link 
                to="/blogS" 
                className="bg-white text-[#9B29FF] py-2 px-6 rounded-full hover:bg-gray-200 transition-colors mb-6 self-start"
            >
                Back to blogs
            </Link>
            <FeatureLabel text="Eloquent-i Blog" />
            <div className="flex flex-col md:flex-row items-start md:items-center gap-8 max-w-6xl w-full">
                <div className="flex-1">
                    <h1 className="text-5xl font-bold text-[#101223] my-4">{blog.Title}</h1>
                    <p className="text-gray-600 mb-4">{blog.Date}</p>
                    <p className="text-gray-700">{blog.ShortDescription}</p>
                </div>

                {blog.ThumbnailFileName && (
                    <div className="flex-1 md:flex-none">
                        <img
                            src={`${process.env.REACT_APP_BLOGS_MEDIA_URL}/${blog.ThumbnailFileName}`}
                            alt={blog.Title}
                            className="w-72 h-auto rounded-xl shadow-lg"
                        />
                    </div>
                )}
            </div>

            <div className="blog-content my-12 bg-white rounded-3xl px-12 py-12 relative z-10 max-w-8xl w-full">
                <div className='content' dangerouslySetInnerHTML={{ __html: blog.Content?.replace(/&nbsp;/g, ' ') }} />
            </div>
        </div>
        </>
    );
};

export default BlogPage;